import { customerPaymentLog } from '@/services/customerPaymentLogs/customerPaymentLogs.types';

export function getCustomerPaymentStatusLabel(status: customerPaymentLog['status'], t: (key: string) => string) {
  if (status === 'PENDING') return t('common.page.table.pending');
  if (status === 'APPROVED') return t('common.page.table.approved');
  return t('common.page.table.rejected');
}
